import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/ui";

export interface BookingPageEmbedProps {
  iframeURL: string;
  className?: string;
  warningMessage?: string;
  showBackButton?: boolean;
  onBack?: () => void;
}

export const BookingPageEmbed = ({
  iframeURL,
  className,
  warningMessage,
  showBackButton,
  onBack,
}: BookingPageEmbedProps) => {
  const { t } = useTranslation("forms");
  const [acknowledgedWarning, setAcknowledgedWarning] = useState(false);

  return (
    <div className={className}>
      {!!showBackButton && (
        <Button variant="outline" size="sm" onClick={onBack}>
          {t("Back")}
        </Button>
      )}

      {!!warningMessage && <p className="text-destructive text-lg font-bold">{warningMessage}</p>}

      {!warningMessage || acknowledgedWarning ? (
        <iframe
          src={iframeURL}
          title="Appointment Booking"
          style={{
            width: "100%",
            height: "800px",
            scale: "0.85",
            border: "none",
          }}
        />
      ) : (
        <Button variant="outline" onClick={() => setAcknowledgedWarning(true)}>
          {t("Show Booking Page Preview")}
        </Button>
      )}
    </div>
  );
};
